export default [
    {
        path: '/cenario-catalogo',
        name: 'cenario-catalogo-index',
        component: () => import('./views/Index.vue'),
        meta: {
            title: 'Cenários de Catálogo',
            icon: 'mdi-chart-box-outline',
            breadcrumbs: [
                { text: 'Cenários de simulação de oferta', disabled: true, href: '/' }
            ]
        }
    },
    {
        path: '/cenario-catalogo/:id',
        name: 'cenario-catalogo-items',
        component: () => import('./views/Items.vue'),
        meta: {
            title: 'Itens do Cenário',
            icon: 'mdi-table-edit',
            breadcrumbs: [
                { text: 'Cenários de Catálogo', disabled: false, href: '/cenario-catalogo' },
                { text: 'Itens do cenário', disabled: true, href: '/' }
            ]
        }
    }
]
